import { MapLatLng } from '../models/map.latlng';
import { MapPolygon } from '../models/map.polygon';
import { MapPolygonPoint } from '../models/map.polygonPoint';
import { HMapComponent } from './hmap.component';

declare var H: any;

export class HPolygon extends MapPolygon {
    private lineString: any;
    private polygon2: any;
    private markers: any = [];
    private hMap: HMapComponent;
    private markerText: any;

    constructor(id: number, map: any, strokeColor: string, strokeOpacity: number, weight: number,
        fillColor: string, fillOpacity: number, editable: boolean, hole: boolean, mapCpn: HMapComponent, content: string) {
        super(id, map, strokeColor, strokeOpacity, weight, fillColor, fillOpacity, editable, hole, content);
        this.lineString = new H.geo.LineString();
        this.hMap = mapCpn;
    }

    addPoint(id: number, content: string, position: MapLatLng, dataModel: any, intermediary: boolean = false): MapPolygonPoint {
        const point = new MapPolygonPoint(id, content, position, dataModel);
        point.intermediary = intermediary;
        this.lineString.pushPoint({ lat: position.lat, lng: position.lng });
        this.points.push(point);
        // Si es editable creo el marcador para el vértice
        if (this.editable) {
            const marker = new H.map.Marker(position, {
                icon: new H.map.Icon(!intermediary ? 'assets/images/circulo.png' : 'assets/images/circulo-int.png', {
                    size: new H.math.Size(32, 32),
                    anchor: new H.math.Point(16, 16)
                }),
                min: 0,
                max: 22
            });
            marker.volatility = true;
            marker.draggable = true;
            marker.setData({ index: this.points.length - 1 });
            this.map.addObject(marker);
            this.markers.push(marker);
            this.points[this.points.length - 1].marker = marker;
            // Comportamiento por defecto al pasar el cursor sobre un marcador
            marker.addEventListener('pointerenter', (event: any) => {
                document.body.style.cursor = 'pointer'
            }, false);
            marker.addEventListener('pointerleave', (event: any) => {
                document.body.style.cursor = this.hMap.defaultCursor;
            }, false);
            marker.addEventListener('drag', (event: any) => {
                const pointer = event.target.getGeometry();
                const data = event.target.getData();
                if (data) {
                    this.points[data.index].point = new MapLatLng(pointer.lat, pointer.lng);
                    this.lineString = new H.geo.LineString();
                    let flag = 0;
                    for (let i = 0; i < this.points.length; i++) {
                        const point = this.points[i];
                        if (!point.intermediary || flag > 1) {
                            this.lineString.pushPoint({ lat: point.point.lat, lng: point.point.lng });
                        } else {
                            if (this.points[i + 1] === this.points[data.index] && point.intermediary) {
                                this.map.removeObject(point.marker);
                                const index = this.markers.indexOf(point.marker, 0);
                                if (index > -1) {
                                    this.markers.splice(index, 1);
                                }
                                this.points.splice(i, 1);
                                this.points[i].moved = false;
                                this.points[i].marker.setData({ index: i });
                                if (this.points[i + 1].intermediary) {
                                    this.map.removeObject(this.points[i + 1].marker);
                                    const index = this.markers.indexOf(this.points[i + 1].marker, 0);
                                    if (index > -1) {
                                        this.markers.splice(index, 1);
                                    }
                                    this.points.splice(i + 1, 1);
                                    flag++;
                                }
                                i--;
                                flag++;
                            } else {
                                if (this.points[i - 1] === this.points[data.index] && point.intermediary) {
                                    this.map.removeObject(point.marker);
                                    const index = this.markers.indexOf(point.marker, 0);
                                    if (index > -1) {
                                        this.markers.splice(index, 1);
                                    }
                                    this.points.splice(i, 1);
                                    this.points[i].moved = false;
                                    this.points[i].marker.setData({ index: i });
                                    i--;
                                    flag++;
                                } else {
                                    if (i === this.points.length - 1 && point.intermediary && data.index === 0) {
                                        this.map.removeObject(point.marker);
                                        const index = this.markers.indexOf(point.marker, 0);
                                        if (index > -1) {
                                            this.markers.splice(index, 1);
                                        }
                                        this.points.pop();
                                        this.points[0].moved = false;
                                    } else {
                                        this.lineString.pushPoint({ lat: point.point.lat, lng: point.point.lng });
                                    }
                                }
                            }
                        }
                    }
                    this.polygon2.setExterior(this.lineString);
                    this.polygon.setGeometry(this.polygon2);
                }
            }, false);
            marker.addEventListener('dragend', (event: any) => {
                const pointer = event.target.getGeometry();
                const data = event.target.getData();
                if (data) {
                    this.points[data.index].point = new MapLatLng(pointer.lat, pointer.lng);
                    this.points[data.index].intermediary = false;
                    this.points[data.index].marker.setIcon(new H.map.Icon('assets/images/circulo.png', {
                        size: new H.math.Size(32, 32),
                        anchor: new H.math.Point(16, 16)
                    }));
                    // Sólo se insertan puntos intermedios una vez por vértice
                    if (!this.points[data.index].moved) {
                        this.points[data.index].moved = true;
                        // Añado dos puntos intermedios
                        this.addIntermediaryPoint(this.points[data.index]);
                    }
                    this.lineString = new H.geo.LineString();
                    this.points.forEach(point => {
                        this.lineString.pushPoint({ lat: point.point.lat, lng: point.point.lng });
                    });
                    this.polygon2.setExterior(this.lineString);
                    this.polygon.setGeometry(this.polygon2);
                    // Evento para que se sepa que ha cambiado el polígono
                    this.hMap.onPolygonDragEnd(this.points[data.index]);
                }
            }, false);
        }
        // Espero a que hayan dos puntos para crear el polígono de lo contrario falla
        if (this.points.length === 2) {
            this.polygon2 = new H.geo.Polygon(this.lineString);
            this.polygon = new H.map.Polygon(
                this.polygon2, {
                volatility: true,
                style: {
                    lineWidth: this.weight,
                    strokeColor: this.hex2rgba(this.strokeColor, this.strokeOpacity),
                    fillColor: this.hex2rgba(this.fillColor, this.fillOpacity)
                }
            });
            this.polygon.setData({ id: id, content: content });
            this.map.addObject(this.polygon);
        } else {
            if (this.polygon !== undefined) {
                this.polygon2.setExterior(this.lineString);
                this.polygon.setGeometry(this.polygon2);
            }
        }
        this.setContentInterno(content, position);
        return point;
    }

    getCentroid(): MapLatLng {
        const centroide = new MapLatLng(0, 0);
        for (let i = 0; i < this.points.length; i++) {
            centroide.lat += this.points[i].point.lat;
            centroide.lng += this.points[i].point.lng;
        }
        centroide.lat /= this.points.length;
        centroide.lng /= this.points.length;
        return centroide;
    }

    addIntermediaryPoint(point: MapPolygonPoint) {
        let i = 0;
        for (; i < this.points.length; i++) {
            if (this.points[i] === point) {
                break;
            }
        }
        let p0: MapPolygonPoint;
        let p2: MapPolygonPoint;
        if (i > 0) {
            p0 = this.points[i - 1];
        } else {
            p0 = this.points[this.points.length - 1];
        }
        if (i < this.points.length - 1) {
            p2 = this.points[i + 1];
        } else {
            p2 = this.points[0];
        }
        const newPunto0 = new MapLatLng(point.point.lat - (point.point.lat - p0.point.lat) / 2,
            point.point.lng - (point.point.lng - p0.point.lng) / 2);
        const newPunto2 = new MapLatLng(point.point.lat - (point.point.lat - p2.point.lat) / 2,
            point.point.lng - (point.point.lng - p2.point.lng) / 2);
        // Añado los puntos intermedios, uno a la izquierda y otro a la derecha
        const newP1 = this.addPoint(0, '', newPunto0, null, true);
        const newP2 = this.addPoint(0, '', newPunto2, null, true);
        // Reordeno todos los puntos del polígono insertando los dos nuevos puntos
        const newPoints: MapPolygonPoint[] = [];
        let flag = false;
        for (let i = 0, j = 0; i < this.points.length - 2; i++, j++) {
            if (this.points[i] === point) {
                if (i > 0) {
                    if (j > 0) {
                        newPoints[j - 1].intermediary = false;
                    }
                    if (i < this.points.length - 3) {
                        this.points[i + 1].intermediary = false;
                    }
                    newPoints.push(this.points[this.points.length - 2]);
                    newPoints[j].marker.setData({ index: j });
                    newPoints.push(point);
                    newPoints[j + 1].marker.setData({ index: j + 1 });
                    newPoints.push(this.points[this.points.length - 1]);
                    newPoints[j + 2].marker.setData({ index: j + 2 });
                    j += 2;
                } else {
                    newPoints.push(point);
                    newPoints.push(this.points[this.points.length - 1]);
                    newPoints[j].marker.setData({ index: j });
                    j++;
                    flag = true;
                }
            } else {
                newPoints.push(this.points[i]);
                newPoints[j].marker.setData({ index: j });
            }
        }
        if (flag) {
            newPoints.push(this.points[this.points.length - 2]);
            newPoints[newPoints.length - 1].marker.setData({ index: newPoints.length - 1 });
        }
        this.points = newPoints;
    }

    // Borra un polígono
    remove() {
        if (this.polygon) {
            this.map.removeObject(this.polygon);
            this.polygon = null;
        }
        if (this.markers) {
            this.markers.forEach((marker: any) => {
                this.map.removeObject(marker);
            });
        }
        this.markers = [];
        if (this.markerText) {
            this.map.removeObject(this.markerText);
        }
    }

    setContentInterno(content: string, position: MapLatLng) {
        // La primera vez creo el texto si hay...
        if (this.content && this.content.length > 0) {
            if (!this.markerText) {
                const width = this.content.length * 10; // Porque la fuente es de 10pt
                const iconText = '<svg width="' + width + '" height="32" xmlns="http://www.w3.org/2000/svg">' +
                    '<text x="' + width / 2 + '" y="' + 10 + '" font-size="10pt" font-family="Verdana" text-anchor="middle">' +
                    this.content + '</text></svg>';
                this.markerText = new H.map.Marker(position, {
                    icon: new H.map.Icon(iconText, {
                        size: new H.math.Size(width, 32),
                        anchor: new H.math.Point(width / 2, 19)
                    }),
                    min: 0,
                    max: 22,
                    volatility: true,
                    visible: true
                });
                this.markerText.draggable = false;
                this.markerText.setData({
                    id: this.id, title: this.content, content: this.content, textMarker: this.markerText, marker: this
                });
                // Asocio el marcador de texto al marcador de imagen
                this.markerText.setData({ id: this.id, title: this.content, content: this.content, marker: this, textMarker: this.markerText });
                // Añado también el marcador con la etiqueta de texto
                this.map.addObject(this.markerText);
            } else {
                this.markerText.setGeometry(this.getCentroid());
            }
        }
    }

    setContent(content: string) {
        this.content = content;
        this.polygon.setData({ id: this.id, content: content });
        for (let i = 0; i < this.points.length; i++) {
            this.points[i].content = content;
        }
        if (this.markerText) {
            this.map.removeObject(this.markerText);
            this.markerText = null;
        }
        this.setContentInterno(content, this.getCentroid());
    }

    hex2rgba(hex: any, alpha = 1) {
        const [r, g, b] = hex.match(/\w\w/g).map((x: any) => parseInt(x, 16));
        return `rgba(${r},${g},${b},${alpha})`;
    }

    // Devuelve el punto del polígono más cercano a un punto dado
    public getNearbyPoint(position: any): any {
        let res: MapPolygonPoint | undefined;
        let i = 0, index = 0;
        let oldDist = 99999999;
        let lastPoint: MapPolygonPoint | undefined;
        for (i = 0; i < this.points.length; i++) {
            if (lastPoint) {
                const dist = this.hMap.distancePointToSegment(lastPoint.point.lng, lastPoint.point.lat, this.points[i].point.lng,
                    this.points[i].point.lat, position.lng, position.lat);
                if (dist < oldDist) {
                    index = i;
                    oldDist = dist;
                }
            }
            lastPoint = this.points[i];
        }
        if (index > 0) {
            if (this.hMap.dist(position.lng, position.lat, this.points[index].point.lng, this.points[index].point.lat) <
                this.hMap.dist(position.lng, position.lat, this.points[index - 1].point.lng, this.points[index - 1].point.lat)) {
                res = this.points[index];
            } else {
                res = this.points[index - 1];
            }
        }
        return res;
    }

}
